import {ROUTES} from 'constants/routes';

export function isProviderProfilePage(pathname: string) {
  return [
    ROUTES.PROVIDER.PROFILE,
    ROUTES.PROVIDER.PROFILE_DETAILS,
    ROUTES.PROVIDER.PROFILE_IN_NETWORK,
    ROUTES.PROVIDER.PROFILE_SETTINGS,
    ROUTES.PROVIDER.PROFILE_RECEIPTS,
    ROUTES.PROVIDER.PROFILE_RESOURCE_CENTER,
  ].includes(pathname);
}
